import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cil-speedometer' },
    // badge: {
    //   color: 'info',
    //   text: 'NEW'
    // }
  },
  {
    name: 'News Feed',
    url: '/newsfeed',
    iconComponent: { name: 'cil-notes' },
  },
  {
    name: 'Visionaries',
    url: '/community',
    iconComponent: { name: 'cil-bookmark' },
  },
  {
    name: 'Research',
    url: '/research',
    iconComponent: { name: 'cil-control' },
  },
  // {
  //   name: 'Community Post List',
  //   url: '/community-post',
  //   iconComponent: { name: 'cil-library' },
  // },
 
  {
    name: 'Search End User',
    url: '/user',
    iconComponent: { name: 'cil-user' },
  },
  {
    name: 'Live Users',
    url: '/live-users',
    iconComponent: { name: 'cil-people' },
  },
   {
    name: 'Categories',
    url: '/categories',
    iconComponent: { name: 'cil-tags' },
  },
  {
    name: 'Marketing page',
    url: '/marketing',
    iconComponent: { name: 'cil-https' },
  },
  {
    name: 'FT Channels',
    url: '/channels',
    iconComponent: { name: 'cil-screen-desktop' },
  },
  {
    name: 'Support ticket page',
    url: '/report-bugs',
    iconComponent: { name: 'cil-list' },
  },
  {
    name: 'Advertisement page',
    url: '/advertisements',
    iconComponent: { name: 'cil-playlist-add' },
  },
  //  {
  //   name: 'Payouts',
  //   url: '/payouts',
  //   iconComponent: { name: 'cil-dollar' },
  // },
  // {
  //   name: 'RPC Wallet',
  //   url: '/wallet',
  //   iconComponent: { name: 'cil-wallet' },
  // },
  {
    name: 'Stream settings',
    url: '/streaming',
    iconComponent: { name: 'cil-media-play' },
  },
  {
    name: 'Storage',
    url: '/storage',
    iconComponent: { name: 'cil-cloud-upload' },
  },
];
